import { IntegrationsService } from '@app/integrations/services/integrations.service';
import { inject, Injectable } from '@angular/core';
import { AppConfig } from '@app/app.config';
import { WINDOW } from '../window.providers';

@Injectable()
export class ContactSupportService {
    private readonly appConfig = inject(AppConfig);
    private readonly integrationsService = inject(IntegrationsService);
    private readonly window = inject(WINDOW);

    contactSupport(): void {
        if (this.integrationsService.isIntegration() && this.integrationsService.getService().getContactSupportLink()) {
            this.window.open(this.integrationsService.getService().getContactSupportLink(), '_blank');
        } else {
            const email = this.appConfig.appInfo.supportEmail;
            const subject = 'Contact support';
            this.window.open(`mailto:${email}?subject=${subject}`, '_blank');
        }
    }
}
